import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { safeFormatDate } from "@/utils/formatDate";

interface PasswordCardProps {
  lastChangedPassword?: string;
}

export function PasswordCard({ lastChangedPassword }: PasswordCardProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-2">
      <div className="text-lg font-semibold text-secondary-foreground">
        Password
      </div>

      <div className="rounded-2xl bg-card shadow-xl px-4 py-6 flex flex-col gap-4 items-center md:flex-row md:justify-between">
        <span className="text-sm text-muted font-medium leading-tight">
          Last Changed {safeFormatDate(lastChangedPassword) ?? "-"}
        </span>
        <Button
          variant="default"
          className="w-full cursor-pointer bg-muted-foreground hover:bg-[#2A2A2A] md:w-2xs"
          onClick={() => navigate("/profile/change-password")}
        >
          Change Password
        </Button>
      </div>
    </div>
  );
}
